import { MessageType } from './enum/message-type';

export class ApplicationMessage {
  public type: MessageType;
  public summary: string;
  public detail: string;
  public sourceId: string;

  //public isSticky: boolean;//TODO implement
  //public displayTime: number;//TODO implement - rmeove particualr message after specified period of time
}
